var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayComponent())?_c('div',[_vm._v(" BASIC TEMPLATE"),_c('br'),_c('v-card',[_c('v-card-title',[_vm._v(" Basic template is active")])],1),_c('v-row',[_vm._v(" MiniWeb Page Basic"),_c('br'),_vm._v(" "+_vm._s(_vm.dataTemplate)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }